module.exports = __webpack_public_path__ + "img/activity-slider-placeholder.25df924.svg";